import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";

/**
 * Has dependency on floorplan-bundle.js
 */

import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import PouchActions, {PouchDocType} from 'app/actions/pouch.actions';

const NS = 'FloorPlanCtrl';

export default function FloorPlanCtrl(
  $log, $state, $rootScope, $window
) {
  "ngInject";

  const vm = this;
  vm.openLayoutPlan = openLayoutPlan;
  vm.openRestaurantPlan = openRestaurantPlan;
  vm.showPlan = $window.config.plan.layout;

  // $rootScope.$on('pouch-synced-doctype-layout', getSectionsLookUp);
  PouchActions.handlePouchSyncedDoctype(PouchDocType.layout, () => getSectionsLookUp());

  getSectionsLookUp();

  function getSectionsLookUp() {
    SectionLookupService.getSectionsLookUp().then(function (sections) {
      vm.sectionsLookup = sections;
      getLayouts();
    }).catch(function (err) {
      $log.error('error getSectionsLookUp', err);
    });
  }

  function getLayouts() {
    LayoutsService.getAllLayouts().then(function (layouts) {
      for (var i = layouts.length - 1; i >= 0; i--) {
        var layout = layouts[i];
        layout.section = vm.sectionsLookup[layout.sectionId];
      }
      vm.layouts = layouts;

      _.each(layouts, function (layout) {
        layout.complete = true;
        TablesLookupService.getAllTablesByIds(layout.tables).then(function (tables) {
          layout.complete = _.reduce(tables, function (complete, table) {
            return complete && table.position != null;
          }, true) && !_.isEmpty(tables);
        });
      });
    }).catch(function (err) {
      $log.error('faild to load layouts', err);
    });
  }

  function openRestaurantPlan(evt) {
    evt.stopPropagation();
    $state.go('settings.sections.plan');
  }

  function openLayoutPlan(evt, layout) {
    evt.stopPropagation();
    $state.go('settings.layouts.plan', {
      id: encodeURIComponent(layout._id)
    });
  }
}
